import type { LogEntry, PlayerView } from '@sw/engine';
import type { ChatMessage } from '@sw/protocol';

type ViewListener = (entries: LogEntry[], prev: PlayerView | null, next: PlayerView) => void;
type ChatListener = (m: ChatMessage) => void;

const viewListeners = new Set<ViewListener>();
const chatListeners = new Set<ChatListener>();
let lastSeq = -1;

/**
 * Bus de eventos de partida: entrega las entradas NUEVAS del log (para animar y sonar).
 * Al cargar o reconectar no se reproducen eventos viejos.
 */
export const gameEvents = {
  onView(prev: PlayerView | null, next: PlayerView): void {
    const maxSeq = next.log.at(-1)?.seq ?? 0;
    if (!prev || lastSeq < 0) {
      lastSeq = maxSeq;
      for (const l of viewListeners) l([], prev, next);
      return;
    }
    const fresh = next.log.filter((e) => e.seq > lastSeq);
    lastSeq = Math.max(lastSeq, maxSeq);
    for (const l of viewListeners) l(fresh, prev, next);
  },
  onChat(m: ChatMessage): void {
    for (const l of chatListeners) l(m);
  },
  subscribe(fn: ViewListener): () => void {
    viewListeners.add(fn);
    return () => viewListeners.delete(fn);
  },
  subscribeChat(fn: ChatListener): () => void {
    chatListeners.add(fn);
    return () => chatListeners.delete(fn);
  },
  reset(): void {
    lastSeq = -1;
  },
};
